import { ReactNode } from 'react'
import { Skeleton } from '@mui/material_modern'

interface SkeletonWrapperProps {
  isLoading: boolean
  children: ReactNode
}

const SkeletonWrapper: React.FC<SkeletonWrapperProps> = ({ isLoading, children }) => {
  if (isLoading) {
    return (
      <Skeleton animation="wave" width="100%" height="100%">
        {children}
      </Skeleton>
    )
  }

  return <>{children}</>
}

SkeletonWrapper.defaultProps = {
  isLoading: false,
}

export default SkeletonWrapper
